import {useId} from 'react';

import PopupFullPage from '@/components/Popup/PopupFullPage/PopupFullPage';
import BadgeDetailScene from '@/containers/BadgeDetailScene/BadgeDetailScene';
import useHideMenu from '@/hooks/useHideMenu';

type BadgeDetailDrawerProps = {
    open: boolean;
    onClose: () => void;
};

const BadgeDetailDrawer = ({open, onClose}: BadgeDetailDrawerProps) => {
    const titleId = useId();

    useHideMenu(open);

    return (
        <PopupFullPage
            animateFromBottom
            // overflow-hidden so the inactive Swiper slide is clipped
            className='overflow-hidden bg-secondary'
            open={open}
            onOpenChange={(isOpen) => !isOpen && onClose()}
            aria-labelledby={titleId}
        >
            <BadgeDetailScene titleId={titleId} />
        </PopupFullPage>
    );
};

export default BadgeDetailDrawer;
